import { ToggleButtonGroup, ToggleButton } from '@mui/material'
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill'

interface SceneButtonExtended {
  children: React.ReactNode
  value?: boolean
  defaultValue?: any
  label?: string
  id?: any
  onChange?: (value: any) => void
}

export const SceneButtonExtended = ({
  children,
  value,
  defaultValue,
  label = '',
  id,
  onChange,
}: SceneButtonExtended) => {
  return (
    <ToggleButtonGroup
      color="primary"
      value={value}
      exclusive
      onChange={onChange}
      style={{
        flex: '1 1 25%',
        margin: '5px 5px',
      }}
    >
      <ToggleButton
        value={value!}
        aria-label={label}
        style={{
          padding: '5px 12px',
          fontSize: '0.5rem',
        }}
        id={id}
      >
        {children}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
